__turbopack_context__.v({
  "avatar": "_mwQhG_avatar",
  "cardGlowPulse": "_mwQhG_cardGlowPulse",
  "glow": "_mwQhG_glow",
  "glowAnimated": "_mwQhG_glowAnimated",
  "profileDetails": "_mwQhG_profileDetails",
  "profileDetailsContainer": "_mwQhG_profileDetailsContainer",
});
